import { useState } from 'react'
import RealEstatePageLayout from '../components/partials/RealEstatePageLayout'
import Link from 'next/link'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import ImageLoader from '../components/ImageLoader'
import Form from 'react-bootstrap/Form'
import { PatternFormat } from 'react-number-format'
import { useFormik } from "formik";
import axios from "axios";
import Swal from "sweetalert2";
import * as yup from "yup";
import 'react-international-phone/style.css';
import { PhoneNumberUtil } from 'google-libphonenumber';
import PhoneInputField from '../components/PhoneInputField'
import { useTranslation } from "react-i18next";


import BgParallax from '../components/BgParallax'

const validationSchema = yup.object({
  fullname: yup.string().required("Veuillez renseigner votre prénom et nom."),
  email: yup.string().email("Veuillez renseigner votre adresse email valide.").required("Veuillez renseigner votre adresse email."),
  // phone_number: yup.string().required("Veuillez renseigner votre numéro de téléphone."),
  phone_number: yup.string()
    .required("le numéro de téléphone est obligatoire")
    .test('is-valid-phone', 'Numéro de téléphone invalide', function (value) {
      if (!value) return false;
      try {
        const phoneUtil = PhoneNumberUtil.getInstance();
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    }),
  id_subject: yup.string().required("Veuillez choisir le sujet."),
  message: yup.string().required("Veuillez renseigner votre message."),
});
const JoinPage = () => {
  const { t } = useTranslation('common');

  const formik = useFormik({
    initialValues: {
      fullname: '',
      id_subject: '1',
      phone_number: '',
      email: '',
      message: '',
    },
    validationSchema,
    validateOnMount: false,
    onSubmit: values => {
      console.log('submitted');
      const formData = new FormData();
      Object.keys(values).map(key => {
        formData.append(key, values[key]);
      });

      axios.post(`${process.env.NEXT_PUBLIC_API_URL}/api/ads/leads/contact-us`, formData).then(function (response) {
        formik.resetForm();
        Swal.fire({
          text: "L'équipe Facilykey vous contactera après avoir examiné votre formulaire",
          icon: "success",
          buttonsStyling: !1,
          confirmButtonText: "Ok, Merci!",
          customClass: {
            confirmButton: "btn btn-primary"
          }
        });
      })
        .catch(function (error) {
          console.error(error);
        });
    },
  });

  return (
    <RealEstatePageLayout
      pageTitle={t("Devenir agent Facilykey")}
      description={t("Devenez agent immobilier indépendant avec Facilykey : formation, outils, visibilité et accompagnement pour développer votre activité au Maroc.")}
      activeNav='Pages'
    >
      <Container className='mt-5 mb-md-4 pt-5'>
        <Breadcrumb className='mb-3 pt-md-3'>
          <Breadcrumb.Item linkAs={Link} href='/'>{t("Accueil")}</Breadcrumb.Item>
          <Breadcrumb.Item active>{t("Rejoindre le réseau")}</Breadcrumb.Item>
        </Breadcrumb>
      </Container>

      {/* Hero */}
      <Container fluid as='section' className='my-5 pb-lg-4 px-xxl-4'>
        <BgParallax
          imgSrc='/images/header/casablanca_header.webp'
          priority
          type='scroll-opacity' // scale, opacity, scroll-opacity, scale-opacity
          speed={0.5} // from -1.0 to 2.0
          overlay={20} // from 0 to 100 or 'gradient' to apply gradient overlay
          contentWrapper={{
            style: { maxWidth: '856px' }
          }}
          className='card align-items-center justify-content-center border-0 p-md-5 p-4 bg-secondary overflow-hidden mt-n3'
          style={{ minHeight: '50vh' }}
        >
          <h1 className='mb-5 pt-5 pb-md-2 px-md-3 text-white text-center'>{t("Rejoignez FacilyKey et donnez de l'élan à votre carrière professionnelle")}</h1>
          <Card className='border-0 bg-secondary p-sm-3 p-2'>
            <Card.Body className='m-1'>
              <Form
                noValidate
                onSubmit={formik.handleSubmit}
              >
                <Row>
                  <Form.Group as={Col} sm={12} controlId='ab-fn' className='mb-3'>
                    <Form.Label>{t("Prénom et nom")} <span className='text-danger'>*</span></Form.Label>
                    <Form.Control onChange={formik.handleChange('fullname')}
                      onBlur={formik.handleBlur('fullname')}
                      isValid={formik.touched.fullname && !Boolean(formik.errors.fullname)}
                      isInvalid={formik.touched.fullname && Boolean(formik.errors.fullname)}
                      value={formik.values.fullname}
                      required />
                    {formik.errors.fullname && formik.touched.fullname ? <Form.Control.Feedback type='invalid'>{t(formik.errors.fullname)}</Form.Control.Feedback> : null}
                  </Form.Group>
                  <Form.Group as={Col} sm={6} controlId='ab-email' className='mb-3'>
                    <Form.Label>{t("Adresse email")}<span className='text-danger'>*</span></Form.Label>
                    <Form.Control type='email'
                      onChange={formik.handleChange('email')}
                      onBlur={formik.handleBlur('email')}
                      isValid={formik.touched.email && !Boolean(formik.errors.email)}
                      isInvalid={formik.touched.email && Boolean(formik.errors.email)}
                      value={formik.values.email}
                      required />
                    {formik.errors.email && formik.touched.email ? <Form.Control.Feedback type='invalid'>{t(formik.errors.email)}</Form.Control.Feedback> : null}
                  </Form.Group>

                  <Form.Group as={Col} sm={6} controlId='ab-phone' className='mb-3'>

                    <Form.Label>{t("Numéro de téléphone")} <span className='text-danger'>*</span></Form.Label>
                    <PhoneInputField formik={formik} />
                  </Form.Group>
                </Row>
                <Form.Group controlId='c-marketing' className='mb-4'>
                  <Form.Label>{t("Comment avez-vous connu le réseau ?")}</Form.Label>
                  <Form.Select defaultValue={formik.values.id_subject}
                    onChange={formik.handleChange('id_subject')}
                    onBlur={formik.handleBlur('id_subject')}
                    isValid={formik.touched.id_subject && !Boolean(formik.errors.id_subject)}
                    isInvalid={formik.touched.id_subject && Boolean(formik.errors.id_subject)}
                    required>
                    <option value='default' disabled>{t('Choisissez une option')}</option>
                    <option value='6'>{t("Réseaux sociaux")}</option>
                    <option value='7'>{t("Par un agent Facilykey")}</option>
                    <option value='8'>{t("Internet")}</option>
                    <option value='9'>{t("Autre")}</option>
                  </Form.Select>
                  {formik.errors.id_subject && formik.touched.id_subject ? <Form.Control.Feedback type='invalid'>{t(formik.errors.id_subject)}</Form.Control.Feedback> : null}
                </Form.Group>
                <Form.Group controlId='comment' className='mb-4'>
                  <Form.Label>{t("Commentaire")} <span className='text-danger'>*</span></Form.Label>
                  <Form.Control as="textarea" rows={3}
                    onChange={formik.handleChange('message')}
                    onBlur={formik.handleBlur('message')}
                    isValid={formik.touched.message && !Boolean(formik.errors.message)}
                    isInvalid={formik.touched.message && Boolean(formik.errors.message)}
                    value={formik.values.message}
                    required />
                  {formik.errors.message && formik.touched.message ? <Form.Control.Feedback type='invalid'>{t(formik.errors.message)}</Form.Control.Feedback> : null}
                </Form.Group>

                <div className='pt-2'>
                  <Button type='submit' size='lg' variant='primary' className='w-sm-auto w-100'>{t("Rejoindre le réseau")}</Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </BgParallax>
      </Container>

      {/* Steps (How it works) */}
      <Container as='section' className='mb-5 pb-2 pb-lg-4'>
        <Row className='gy-4 pb-2 pb-sm-4 align-items-center'>
          <Col xs={12} md={7}>
            <h2 className='h2 mb-lg-5 mb-sm-4'>{t("Pourquoi choisir Facilykey")}</h2>
            <div className='steps steps-vertical'>
              <div className='step active'>
                <div className='step-progress'><span className='step-number'>1</span></div>
                <div className='step-label ms-4'>
                  <h3 className='h5 mb-2 pb-1'>{t("Une activité enrichissante")}</h3>
                  <p className='mb-0'>{t("Devenez un acteur clé du marché immobilier en aidant vos clients à concrétiser leurs projets. Chaque jour est une nouvelle opportunité d’apprendre, de grandir et de relever des défis passionnants.")}</p>
                </div>
              </div>
              <div className='step active'>
                <div className='step-progress'><span className='step-number'>2</span></div>
                <div className='step-label ms-4'>
                  <h3 className='h5 mb-2 pb-1'>{t("Un accompagnement personnalisé")}</h3>
                  <p className='mb-0'>{t("Facilykey vous fournit les outils, les formations et le soutien nécessaires pour exceller. Vous serez encadré à chaque étape de votre parcours, de vos débuts jusqu’à votre réussite.")}</p>
                </div>
              </div>
              <div className='step active'>
                <div className='step-progress'><span className='step-number'>3</span></div>
                <div className='step-label ms-4'>
                  <h3 className='h5 mb-2 pb-1'>{t("Des revenus attractifs")}</h3>
                  <p className='mb-0'>{t("Gagnez en fonction de vos efforts et de vos résultats. Chez Facilykey, votre engagement est valorisé, et vos performances déterminent votre succès financier.")}</p>
                </div>
              </div>
              <div className='step active'>
                <div className='step-progress'><span className='step-number'>4</span></div>
                <div className='step-label ms-4'>
                  <h3 className='h5 mb-2 pb-1'>{t("Une carrière évolutive")}</h3>
                  <p className='mb-0'>{t("Intégrez une structure qui valorise votre ambition et offre des possibilités d’évolution. Votre investissement aujourd’hui peut ouvrir la voie à des opportunités encore plus grandes demain.")}</p>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={5} className='text-md-start text-center'>
            <div className='d-inline-block'>
              <ImageLoader src='/images/illustrations/devenir_bloc.jpeg' width={700} height={500} alt={t("Devenir agent Facilykey")} className={'rounded'} />
            </div>
          </Col>
        </Row>
      </Container>

      {/* Links */}
      <Container as='section' className='d-none mb-5 pb-md-3 pb-lg-5'>
        <h2 className='h3 mb-4'>Accessible à tous les profils</h2>
        <Row md={12} className='gy-3'>
          <Col>
            <Card className='card-hover h-100 border-0 bg-faded-accent position-relative'>
              <Card.Body className='pb-2'>
                <h5 className='mb-2 pb-1'>Je débute dans l'immobilier</h5>
                <p className='mb-0'>Faites rapidement l'estimation de votre bien immobilier.</p>
              </Card.Body>
              <Card.Footer className='py-1 border-0'>
                <Button as={Link} href='/real-state/help-center' variant='link stretched-link text-primary mb-3 px-0'>Démarrer une nouvelle vie</Button>
              </Card.Footer>
            </Card>
          </Col>
          <Col>
            <Card className='card-hover h-100 border-0 bg-faded-accent position-relative'>
              <Card.Body className='pb-2'>
                <h5 className='mb-2 pb-1'>Je suis agent immobilier</h5>
                <p className='mb-0'>Choisissez l'interlocuteur le plus proche de votre secteur de recherche.</p>
              </Card.Body>
              <Card.Footer className='py-1 border-0'>
                <Button as={Link} href='/real-state/help-center' variant='link stretched-link text-primary mb-3 px-0'>Je souhaite en savoir plus</Button>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </Container>

    </RealEstatePageLayout>
  )
}

export default JoinPage
